import React, { useEffect, useRef } from 'react'

import BigLoaderComponent from '../../../sharedLegacy/components/BigLoaderComponent/BigLoaderComponent'

import './ConnectingScreen.scss'

type ConnectingScreenProps = {
  text?: string
}

const ConnectingScreen = ({ text }: ConnectingScreenProps) => {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (dialog && !dialog.open) dialog.showModal()
    return () => dialog?.close()
  }, [])

  return (
    <dialog
      ref={dialogRef}
      className="connecting-screen"
      aria-live="polite"
      onCancel={(event) => event.preventDefault()}
    >
      <BigLoaderComponent loadingText={text} />
    </dialog>
  )
}

export { ConnectingScreen }
